import useMediaQuery from "@hooks/useMediaQuery";
import { ReactComponent as CaretBackSVG } from "@images/caret_back.svg";
import { Device } from "@styles/constants";
import Link from "next/link";
import {
  Container,
  Back,
  ListButton,
  ListButtonMobile,
  ListButtonSVG,
  StickyMobile,
} from "./CatalogSidebar.styled";

export interface CatalogSidebarProps {
  listButtonText: string;
  backLink?: string;
}

const CatalogSidebar = ({ listButtonText, backLink }: CatalogSidebarProps) => {
  const isDesktop = useMediaQuery(Device.largeUp);

  return (
    <>
      {!isDesktop ? (
        <StickyMobile>
          <Link href={backLink} passHref legacyBehavior>
            <ListButtonMobile>
              <CaretBackSVG />
              <span>{listButtonText}</span>
            </ListButtonMobile>
          </Link>
        </StickyMobile>
      ) : (
        <Container>
          {/* MIR-554 hidding back button, we'll bring it back in the future. <Back><BackButton href={backLink} /></Back> */}

          <Link href={backLink} passHref legacyBehavior>
            <ListButton>
              <span>{listButtonText}</span>

              <ListButtonSVG>
                <CaretBackSVG />
              </ListButtonSVG>
            </ListButton>
          </Link>
        </Container>
      )}
    </>
  );
};

export default CatalogSidebar;
